import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";

import ContactInformationForm from "./contactInformationBlock/ContactInformationForm";
import SignInBlock from "./SignInBlock";
import { useSelector } from "react-redux";

const ContactInformationBlock = () => {
  const { contactDetails, isLoggedIn } = useSelector((s) => ({
    ...s.checkout,
    ...s.auth,
  }));

  return (
    <div>
      <div className="gkit-d-flex gkit-items-end gkit-justify-between gkit-gap-3 gkit-mb-3">
        <p className="gkit-p-20 gkit-bold gkit-m-0">Contact information</p>
        {!isLoggedIn && <SignInBlock />}
      </div>
      <Formik
        enableReinitialize={true}
        initialValues={
          contactDetails || { email: "", first_name: "", last_name: "" }
        }
        validationSchema={Yup.object().shape({
          email: Yup.string()
            .email("Please enter a valid email.")
            .required("Please enter an email address."),
          first_name: Yup.string().required("Please enter a valid first name."),
          last_name: Yup.string().required("Please enter a valid last name."),
        })}
      >
        {(formikProps) => (
          <ContactInformationForm isLoggedIn={isLoggedIn} {...formikProps} />
        )}
      </Formik>
    </div>
  );
};

export default ContactInformationBlock;
